import { InfoCircleTwoTone } from "@ant-design/icons";
import { Popover, Space } from "antd";
import { AccountOwner } from "models/applicationUsers";
import { BreakerCardOwner } from "models/breaker";
import { isNewSilentUser } from "util/helpers";
import MultiValueDisplay from "./MultiValueDisplay";

const isAccountOwner = (value: BreakerCardOwner | AccountOwner): value is AccountOwner =>
    "accountId" in value;

const Owner = (props: { owner: BreakerCardOwner | AccountOwner }) => {
    const { owner } = props;

    if (isAccountOwner(owner) && !isNewSilentUser(owner)) {
        return <MultiValueDisplay
            title={`${owner.firstName} ${owner.lastName}`}
            subTitle={owner.email}
        />
    }

    return <MultiValueDisplay
        title={owner.userName}
        subTitle={owner.email}
    />
}

const OwnersDisplay = (props: { owners: BreakerCardOwner[] | AccountOwner[], displayEmail?: boolean }) => {
    const displayEmail = props.displayEmail === undefined
        ? true
        : props.displayEmail!;

    if (props.owners.length === 1) {
        const owner = props.owners[0];
        const title = isAccountOwner(owner) && !isNewSilentUser(owner)
            ? `${owner.firstName} ${owner.lastName}`
            : owner.userName;

        return <MultiValueDisplay
            title={title}
            subTitle={displayEmail ? props.owners[0].email : ''}
        />
    }

    const content = <Space direction="vertical" size="middle">
        {props.owners.map((o, idx) => <Owner key={idx} owner={o} />)}
    </Space>;

    return <Space>
        <span>{`${props.owners.length} Owners`}</span>
        <Popover content={content} >
            <InfoCircleTwoTone style={{ cursor: 'pointer' }} />
        </Popover>
    </Space>
};

export default OwnersDisplay;